import { userService } from '@/projects/admin/services/user-service';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { DataGrid } from 'devextreme-react';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const UserList = () => {
    const dataGridRef = useRef<DataGrid>(null);
    const [mainStore] = useState(() => createCustomStore({
        key: ['id'],
        load: userService.userList,
        byKey: (key, loadOptions: any) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
    }));
    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/admin/user-definition/${id}`, { state: { id: id } })
    }

    return (
        <>
            <DataGridWrapper
                props={{ id: 'user-list', ref: dataGridRef, wordWrapEnabled: true }}
                permissonCode='Admin.User.User'
                datasource={mainStore}
                editingConfig={{ allowUpdating: true }}
                headerFilterVisible={true}
                filterVisible={true}
                pagerVisible={true}
                enableCustomToolbarContent={true}
                navigateNewRecordPath='/admin/user-definition'
                columns={[
                    {
                        dataField: 'userName',
                        caption: 'Kullanıcı Adı',
                        allowSearch: true,
                    },
                    {
                        dataField: 'email',
                        caption: 'Email',
                        allowSearch: true,
                    },
                    {
                        dataField: 'accountName',
                        caption: 'Account',
                        allowSearch: true,
                    }
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: (e: any) => goToEdit(e.row?.data.id),
                    },
                ]}
            />

        </>

    )
}
export default UserList